  <template>
    <transition name="fade">
      <div
        v-if="visible"
        class="notification"
        :class="[type]"
      >
        <div class="icon-container">
          <span class="icon material-symbols-outlined">{{ icon }}</span>
        </div>
        <div class="notification-content">
          <h4 class="title">{{ title }}</h4>
          <p class="message">{{ message }}</p>
        </div>
      </div>
    </transition>
  </template>

  <script>
  export default {
    props: {
      type: { type: String, default: "success" }, // 'success', 'error', 'hold'
      title: { type: String, required: true },
      message: { type: String, required: true },
      duration: { type: Number, default: 1000 },
    },
    data() {
      return {
        visible: true,
      };
    },
    computed: {
      icon() {
        switch (this.type) {
          case "success":
            return "check_circle";
          case "error":
            return "cancel";
          case "hold":
            return "report";
          default:
            return "";
        }
      },
    },
    mounted() {
      if (this.duration) {
        setTimeout(this.closeNotification, this.duration);
      }
    },
    methods: {
      closeNotification() {
        this.visible = false;
        this.$emit("closed");
      },
    },
  };
  </script>

  <style scoped>
  .notification {
    position: fixed;
    right: 0;
    top: 5rem;
    margin-right: 10px;
    display: flex;
    align-items: center;
    padding: 17px;
    border-radius: 8px;
    background-color: #fff; /* Beyaz arka plan */
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1); /* Hafif gölgelendirme */
    width: fit-content;
    min-width: 15%;
    max-width: 90%;
    z-index: 1000;
    animation: fade-in 0.3s ease;
  }
  .notification.success .icon-container {
    background-color: #9effa5; 
  }
  .notification.error .icon-container {
    background-color: #ff9fae; 
  }
  .notification.hold .icon-container {
    background-color: #ffda9e; 
  }
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 25%;
    margin-right: 0.5rem; 
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1); 
  }
  .icon {
    font-size: 20px;
  }
  .notification.success .icon {
    color: #4caf50;
  }
  .notification.error .icon {
    color: #f44336; 
  }
  .notification.hold .icon {
    color: #ff9800; 
  }
  .notification-content {
    display: flex;
    flex-direction: column;
  }
  .title {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  .message {
    margin: 0;
    font-size: 12px;
    color: #666;
  }
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateX(100%);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slide-out {
    from {
      opacity: 1;
      transform: translateX(0);
    }
    to {
      opacity: 0;
      transform: translateX(100%);
    }
  }

  .fade-enter-active {
    animation: slide-in 0.3s ease-out;
  }

  .fade-leave-active {
    animation: slide-out 0.3s ease-out;
  }

  @media screen and (max-width: 768px) {
  .notification {
    min-width: 40%;
  }
}
</style>
